import { render } from "./FlyingImages.vue?vue&type=template&id=84735cb6&scoped=true"
import script from "./FlyingImages.vue?vue&type=script&lang=js"
export * from "./FlyingImages.vue?vue&type=script&lang=js"

import "./FlyingImages.vue?vue&type=style&index=0&id=84735cb6&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-84735cb6"

export default script